import { Validator } from "../validator"

enum GenderError {
    EMPTY = `errors.required`,
}

class GenderValidator implements Validator<string, GenderError> {
    validate(entry: string): GenderError | undefined {
        if (entry === ``) {
            return GenderError.EMPTY
        }
    }
}

export default GenderValidator
export { GenderError }